import type { Paragraph } from './types';
import { showToast } from './ui';

interface State {
  paragraphs: Paragraph[];
  speakerMap: Record<number, string>;
  isEditMode: boolean;
  selectedBubbles: Set<number>;
  undoStack: Paragraph[][];
  currentAudioUrl: string | null;
  currentFile: File | null;
}

export const state: State = {
  paragraphs: [],
  speakerMap: {},
  isEditMode: false,
  selectedBubbles: new Set(),
  undoStack: [],
  currentAudioUrl: null,
  currentFile: null,
};

const TRANSCRIPT_KEY = 'scribe_saved_transcript';
const SPEAKERS_KEY = 'scribe_saved_speakers';
const AUDIO_URL_KEY = 'scribe_saved_audio_url';
const DEEPGRAM_KEY = 'scribe_deepgram_key';
const GEMINI_KEY = 'scribe_gemini_key';

let saveToastTimer: number | null = null;
let lastSaveToastAt = 0;

function notifySaved(): void {
  const now = Date.now();
  if (now - lastSaveToastAt > 2000) {
    showToast('Guardado', 'success', 1200);
    lastSaveToastAt = now;
  } else if (saveToastTimer === null) {
    saveToastTimer = window.setTimeout(() => {
      saveToastTimer = null;
      showToast('Guardado', 'success', 1200);
      lastSaveToastAt = Date.now();
    }, 2000);
  }
}

export function saveTranscript(): void {
  if (state.paragraphs.length > 0) {
    localStorage.setItem(TRANSCRIPT_KEY, JSON.stringify(state.paragraphs));
    localStorage.setItem(SPEAKERS_KEY, JSON.stringify(state.speakerMap));
    if (state.currentAudioUrl && !state.currentAudioUrl.startsWith('blob:')) {
      localStorage.setItem(AUDIO_URL_KEY, state.currentAudioUrl);
    } else {
      localStorage.removeItem(AUDIO_URL_KEY);
    }
    notifySaved();
  } else {
    localStorage.removeItem(TRANSCRIPT_KEY);
    localStorage.removeItem(SPEAKERS_KEY);
    localStorage.removeItem(AUDIO_URL_KEY);
  }
}

export function loadTranscript(): boolean {
  const raw = localStorage.getItem(TRANSCRIPT_KEY);
  if (!raw) return false;
  try {
    state.paragraphs = JSON.parse(raw) as Paragraph[];
    const speakers = localStorage.getItem(SPEAKERS_KEY);
    state.speakerMap = speakers ? (JSON.parse(speakers) as Record<number, string>) : {};
    state.currentAudioUrl = localStorage.getItem(AUDIO_URL_KEY);
    return true;
  } catch (err) {
    console.error('Error restaurando transcripción:', err);
    return false;
  }
}

export function getDeepgramKey(): string | null {
  return localStorage.getItem(DEEPGRAM_KEY);
}

export function setDeepgramKey(key: string): void {
  if (key) localStorage.setItem(DEEPGRAM_KEY, key);
  else localStorage.removeItem(DEEPGRAM_KEY);
}

export function getGeminiKey(): string | null {
  return localStorage.getItem(GEMINI_KEY);
}

export function setGeminiKey(key: string): void {
  if (key) localStorage.setItem(GEMINI_KEY, key);
  else localStorage.removeItem(GEMINI_KEY);
}

export function saveUndoState(): void {
  state.undoStack.push(JSON.parse(JSON.stringify(state.paragraphs)));
  const btn = document.getElementById('undoBtn') as HTMLButtonElement | null;
  if (btn) btn.disabled = false;
}
